<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Send Money</p>
                        <!--<p class="sub">From me to me</p>-->
                        <p class="sub">To Phone Number</p>
                    </div>
                </div>
            </div>

            <!--        Intro Text-->
            <div class="form-component">

                <div class="card mb-4">
                    <div class="card-body">
                        <!--<div class="card-title">From Me TO Me</div>-->
                        <div class="card-title">To Phone Number</div>
                        <!--<p>-->
                        <!--{{getFullBankList}}-->
                        <!--</p>-->
                        <div class="card-content">
                            <form @submit.prevent="fundsTransferStep1">
                                <div class="alert-box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                {{alert.message}}
                                            </ui-alert>
                                        </div>
                                    </div>
                                </div>

                                <!--<form>-->
                                <div class="row">
                                    <div class="col-md-6 form-group mb-2">
                                        <!--<accounts-select-box></accounts-select-box>-->
                                        <label>Debit Account*</label>
                                        <ui-select
                                                ref="debitAccountSelect"
                                                placeholder="Select Debit Account"
                                                type="basic"
                                                :options="dat"
                                                error="You must select at least 1 colours"
                                                :invalid="debitAcctTouched && debitAcct.length < 1"
                                                @touch="debitAcctTouched = true"
                                                v-model="debitAcct"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">

                                        <label for="form-input-phone-no" class="form-label">Phone Number </label>
                                        <vue-tel-input
                                                @onInput="onInput" id="form-input-phone-no" class="form-input-phone-no"
                                                v-model="phone.number" v-bind="bindProps"
                                        ></vue-tel-input>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label>Name*</label>
                                        <input
                                                type="text" id="name" class="form-control"
                                                value="" placeholder="Name" data-vv-name="Name"
                                                v-model="name" name="amount" required  v-validate="'required'"
                                        >

                                        <span v-show="errors.has('name')" class="error-span is-danger">{{ errors.first('name') }}</span>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label for="amount">Amount*</label>
                                        <div class="amount-input">
                                            <div class="currency">
                                                <span>&#8358;</span>
                                            </div>

                                            <input
                                                    type="text" id="amount" class="input"
                                                    value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                    v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                    @change="amountOnChange(amount)"
                                            >
                                        </div>

                                        <span v-show="errors.has('amount')" class="error-span is-danger">{{ errors.first('amount') }}</span>
                                    </div>

                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-xnax push-right">Submit</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import VueTelInput from 'vue-tel-input';

    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";



    export default {
        name: "phoneTransfer",
        components: {
            FooterMobile,
            VueTelInput,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                debitAcct:  '',
                debitAcctTouched:  false,
                creditBank: '',
                creditBankCode: '',
                creditAccount: '',
                amount: '',
                narration: '',
                alias: '',

                phone: {
                    number: '',
                    isValid: false,
                    country: undefined,
                },

                bindProps: {
                    placeholder: 'Phone Number',
                    required: true,
                    disabledFetchingCountry: true,
                    defaultCountry: 'NG',
                    preferredCountries: ['NG', 'GB', 'US', 'CA'],
                    disabledFormatting: true,
                },
                name: '',

                accountExists: false,

                possibleBankList: [],
                possBankList: [],
                fullBankLeest: [],
                postBody: {},

                dat: [],

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getFullBankList',
                'getUsername',
                'getCurrentTransferPhoneNo',
            ])
        },
        created () {
            this.popDebitAcct()

            this.phone.country = this.getCurrentTransferPhoneNo[0];
            this.phone.number = this.getCurrentTransferPhoneNo[1];
        },
        methods: {
            ...mapActions([
                'updateNetworkErrorState',
                'updateSideBarPage',
                'updateAppLoading',
                'updateInsideCurrentPage',
                'updateConfirmationPageBody',
            ]),

            backButton(){
                this.updateInsideCurrentPage('sendMoney')
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },


            generateUUID () {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },

            clearKeenUiSelect(ref) {
                this.$refs[ref].clearSelection();
            },
            FTResetAllInputField(){
                this.possibleBankList = [];
                this.possBankList = [];

                this.debitAcct = "";
                this.creditBank = "";
                this.creditBankCode= '';
                this.creditAccount= '';
                this.amount= '';
                this.narration= '';
                this.savebene= false;
                this.alias= '';
                this.tpin= '';

                this.postBody = {};
            },
            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){
                        // console.log('I Banker Account')
                    } else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },

            onInput({ number, isValid, country }) {
                this.phone.number = number;
                this.phone.isValid = isValid;
                this.phone.country = country && country.dialCode;
            },
            fundsTransferStep1(){
                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else {
                    this.alert.show = false;
                    this.saveDetailsForNameEnquiry()
                }

            },
            saveDetailsForNameEnquiry(){
                this.alert.show = false;


                //start app running
                this.updateAppLoading(true);

                axios
                    .post('/querycustomer',
                        {
                            querytype: 'mobilenumber',
                            accountnumber: '',
                            countrycode: this.phone.country,
                            mobilenumber: this.phone.number,
                        },
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData =  response.data

                        if (responseData.responsecode === '00') {
                            //(IE) Account Exists
                            // console.log('Name Inquiry Response ==>', responseData)

                            let rubiesBankDetails = {
                                bankcode: "090175",
                                bankname: "HighStreet MFB",
                                nubancode: "32",
                            }

                            //    prepare the post Body
                            let pastBody ={
                                debitAcct:  this.debitAcct.value,
                                creditBank: rubiesBankDetails,
                                creditAccount: responseData.accountno,
                                amount: this.amount,
                                showNarration: true,
                                confirmationType: 'SEND MONEY CONFIRMATION',
                                confirmationTypeSub: 'To Phone Number',
                                transactionType: 'phoneTransfer',
                                creditAccountName: responseData.customername,
                                narration:  'Transfer from ' + this.debitAcct.value.accountname + ' to ' + responseData.customername,
                            }
                            // console.log('Post Body ===>>', pastBody)

                            // Save Details in the Store for Name Enquiry
                            this.updateConfirmationPageBody(pastBody);

                            // console.log('final PAST Body', pastBody);

                            //Update the current sub component in the store
                            this.updateInsideCurrentPage('confirmation')
                        }
                        else if (responseData.responsecode === '02') {
                            //(IE) Account Doesnt Exist
                            // console.log('Name Inquiry Response account doesnt exist ==>', responseData)

                            // this.postBody.creditAccountName = this.step1Response.accountname;
                            let rubiesBankDetails = {
                                bankcode: "090175",
                                bankname: "HighStreet MFB",
                                nubancode: "32",
                            }
                            //    prepare the post Body
                            let pastBody ={
                                debitAcct:  this.debitAcct.value,
                                creditBank: rubiesBankDetails,
                                creditAccount: this.phone.number,
                                countrycode: this.phone.country,
                                amount: this.amount,
                                showNarration: true,
                                confirmationType: 'SEND MONEY CONFIRMATION',
                                confirmationTypeSub: 'To Phone Number',
                                transactionType: 'phoneTransfer2',
                                creditAccountName: this.name,
                                narration:  'Transfer from ' + this.debitAcct.value.accountname + ' to ' + this.name,
                            }

                            // Save Details in the Store for Name Enquiry
                            this.updateConfirmationPageBody(pastBody);

                            // console.log('final PAST Body', pastBody);

                            //Update the current sub component in the store
                            this.updateInsideCurrentPage('confirmation')
                        }
                        else {
                            // this.FTResetAllInputField();

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);
                        this.closeModal('selectBankModal');

                        // display error notification
                        this.showAlert(true, 'error', 'Network Error')

                        // set network error state to true
                        this.updateNetworkErrorState(true);
                    })
            },
        },
        mounted(){
            this.$nextTick(()=>{})
        },
    }
</script>

<style scoped>
    .selectWrapper{
        border-radius: 20px;
        display: block;
        overflow: hidden;
        background: #f4f6fa;
        border: none;
        padding: 0 8px;
    }
    .selectBox{
        background-color: transparent !important;
    }
    .selectBox:focus{
        box-shadow: none;
    }



    /*.selectBox{border-radius:4px;border:1px solid #AAAAAA;}*/
</style>